import React from "react";

const StampText = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17.249"
      height="21"
      viewBox="0 0 17.249 21"
      className="svg-stamp-from-text"
    >
      <path
        id="Union_10"
        data-name="Union 10"
        d="M1.888,19.99a1.972,1.972,0,0,1-.824-.19A1.806,1.806,0,0,1,0,18.04Q0,10,0,1.969c0-.059,0-.118,0-.176A1.879,1.879,0,0,1,.662.45,2.224,2.224,0,0,1,1.641,0h10.39a1.945,1.945,0,0,1,.32.214Q14.2,2.052,16.039,3.9a.683.683,0,0,1,.211.506q0,6.854,0,13.708A1.857,1.857,0,0,1,14.367,20q-2.674,0-5.348,0Q5.453,20,1.888,19.99ZM1.249,2.038V17.954c0,.569.224.8.79.8H14.205c.569,0,.794-.224.794-.79V5h-.228c-.736,0-1.472,0-2.207,0a1.245,1.245,0,0,1-1.314-1.307c0-.742,0-1.484,0-2.226V1.249h-9.2C1.475,1.249,1.249,1.474,1.249,2.038Zm2.9,14.055a.462.462,0,0,1-.08-.527.527.527,0,0,1,.5-.313H8.137q1.766,0,3.534,0a.517.517,0,0,1,.553.612.511.511,0,0,1-.443.4c-.059.006-.117.007-.176.007q-3.474,0-6.949,0A.592.592,0,0,1,4.146,16.093Zm0-3.706a.461.461,0,0,1-.08-.526.524.524,0,0,1,.5-.313H8.137q1.766,0,3.534,0a.516.516,0,0,1,.553.612.51.51,0,0,1-.443.4,1.581,1.581,0,0,1-.176.007q-3.474,0-6.949,0A.593.593,0,0,1,4.146,12.387Zm0-3.7a.462.462,0,0,1-.08-.527.525.525,0,0,1,.5-.313H8.137q1.766,0,3.534,0a.517.517,0,0,1,.553.612.511.511,0,0,1-.443.4c-.059.006-.117.007-.176.007q-3.474,0-6.949,0A.592.592,0,0,1,4.146,8.683Z"
        transform="translate(0.499 0.5)"
        stroke="rgba(0,0,0,0)"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </svg>
  );
};

export default StampText;
